import React from 'react';
import DisplayingRange from 'components/includes/DisplayingRange';
import BackToTopButton from 'components/Generic/Buttons/BackToTopButton';

type Props = {
  totalFunds: number;
  currentPage: number;
  take: number;
  className: string;
  isLoading: boolean;
};

const FundsListingFooter: React.FC<Props> = ({
  totalFunds,
  take,
  currentPage,
  className = '',
  isLoading,
}) => {
  return (
    <div
      className={`funds-listing__footer d-flex flex-column flex-md-row justify-content-between ${className}`}
    >
      <DisplayingRange
        className="footnote text-grey order-1 order-md-0"
        dictionaryKey="paginationDisplayingResults"
        page={currentPage}
        take={take}
        total={totalFunds}
        showSkeleton={isLoading}
      />
      <BackToTopButton className="ms-0 order-0 order-md-1 align-self-center align-self-md-auto mb-4 mb-md-0" />
    </div>
  );
};

export default FundsListingFooter;
